import type { ComponentProps, JSX } from 'react';

import { Button } from '@change/ds-core-ui';

type Props = Omit<ComponentProps<typeof Button>, 'onClick'> & {
	onClick?: () => void;
};

export function CustomButton({ children, inverted, onClick, ...rest }: Props): JSX.Element {
	return (
		// eslint-disable-next-line @change-corgi/require-data-qa-attribute
		<Button variant="primary" className="w-full" onClick={() => onClick?.()} {...rest}>
			{children}
		</Button>
	);
}
